import { render, staticRenderFns } from "./promptConfigNewSystem.vue?vue&type=template&id=688d2098&"
import script from "./promptConfigNewSystem.vue?vue&type=script&lang=js&"
export * from "./promptConfigNewSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports